/* eslint-disable @typescript-eslint/no-explicit-any */
import { Dropdown } from "react-bootstrap";
import AwesomeIcon from "@icons/AwesomeIcon";
import SntExportIcon from "@icons/SntExportIcon";
import ElasticKibanaIcon from "@images/elastic-kibana.svg";
import { LanguageKey } from "@/types/generated/LanguageKey";
import { translate } from "@/hooks/useLanguage";
import GlobalUtils from "@/utils/GlobalUtils";
import { getCellCopyData } from "../../../utils/cellUtils";

interface DataActionsProps {
  column: any;
  rows: any[];
  prepareRow: (row: any) => void;
  isDisabledCopyData: boolean;
  onExtraColumnActionClicked?: (action: string, params: any) => void;
  organisationType?: string;
}

export const DataActions = ({
  column,
  rows,
  prepareRow,
  isDisabledCopyData,
  onExtraColumnActionClicked,
  organisationType,
}: DataActionsProps) => {
  const showDataActions =
    (onExtraColumnActionClicked || !isDisabledCopyData || column.supportKibanaKey) &&
    !column.isGrouped;

  if (!showDataActions) return null;

  const getColumnData = () => {
    let list: any[] = [];
    rows.forEach((row: any) => {
      prepareRow(row);
      const cellValue = getCellCopyData(column, row.original);
      list = [...list, ...cellValue];
    });
    const uniqueSet = new Set(list);
    return [...uniqueSet];
  };

  const handleCopyToClipboard = () => {
    const uniqueList = getColumnData();
    navigator.clipboard.writeText(uniqueList.join(","));
  };

  const handleOpenKibana = () => {
    const uniqueList = getColumnData();
    const url = GlobalUtils.getKibanaLinkByFilter(
      "now-30m",
      "now",
      column.supportKibanaKey,
      uniqueList,
      "desc"
    );
    window.open(url, "_blank");
  };

  const handleExport = () => {
    onExtraColumnActionClicked?.("export", { columnKey: column.key });
  };

  return (
    <>
      {!isDisabledCopyData && (
        <Dropdown.Item bsPrefix="dropdown-item" onClick={handleCopyToClipboard}>
          <div className="d-flex">
            <div style={{ width: 20 }} className="d-flex align-items-center">
              <AwesomeIcon icon={["far", "copy"]} />
            </div>
            <div>{translate(LanguageKey.copy_clumn_clipboard_key)}</div>
          </div>
        </Dropdown.Item>
      )}
      {column.supportKibanaKey && organisationType === "SYSTEM" && (
        <Dropdown.Item bsPrefix="dropdown-item" onClick={handleOpenKibana}>
          <div className="d-flex">
            <div style={{ width: 20 }} className="d-flex align-items-center">
              <img
                alt=""
                src={ElasticKibanaIcon}
                style={{ width: 16, height: 16 }}
              />
            </div>
            <div>Go to kibana with column data filter</div>
          </div>
        </Dropdown.Item>
      )}
      {onExtraColumnActionClicked && (
        <Dropdown.Item bsPrefix="dropdown-item" onClick={handleExport}>
          <div className="d-flex">
            <div style={{ width: 20 }} className="d-flex align-items-center">
              <SntExportIcon />
            </div>
            <div>{translate(LanguageKey.export_full_column_key)}</div>
          </div>
        </Dropdown.Item>
      )}
      <Dropdown.Divider className="table-group-menu-divider" />
    </>
  );
};
